import { cubicBezier } from 'motion/react'

export const easeShort = {
  duration: 0.2,
  ease: cubicBezier(0.5, 0, 0, 1),
}

export const easeMedium = {
  duration: 0.4,
  ease: cubicBezier(0.5, 0, 0, 1),
}

export const easeLong = {
  duration: 1,
  ease: cubicBezier(0.5, 0.05, 0.1, 1),
}
